const listColumn = {
  TICKER: 'ticker',
  SECTOR_NAME: 'sectorName',
  PRICE: 'price',
  ISA3: 'financial.isa3',
  ISA20: 'financial.isa20',
  NET_PROFIT_GROWTH: 'financial.rtq83',
  EBIT_MARGIN: 'financial.rtq27',
  RTD14: 'financial.rtd14',
  RTD7: 'financial.rtd7',
  CHANGE_PRICE: 'priceChange',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
};

const listHideColumn = [
  'priceChange',
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
];

export default {
  listColumn,
  listHideColumn,
};
